import { useContext } from "react";
import { AbilityContext } from "../context/AbilityContext";

export default function useAbility() {
  return useContext(AbilityContext);
}
